import { numEn, plural } from '../helpers';
import type { Dict } from '../id';

export const common: Dict['common'] = {
  // actions
  cancel: 'Cancel',
  save: 'Save',
  close: 'Close',
  delete: 'Delete',
  remove: 'Remove',
  download: 'Download',
  upload: 'Upload',
  edit: 'Edit',
  add: 'Add',
  create: 'Create',
  import: 'Import',
  export: 'Export',
  copy: 'Copy',
  copied: 'Copied',
  send: 'Send',
  open: 'Open',
  view: 'View',
  preview: 'Preview',
  search: 'Search',
  select: 'Select',
  replace: 'Replace',
  rename: 'Rename',
  attach: 'Attach',
  reload: 'Reload',
  refresh: 'Refresh',
  retry: 'Try again',
  later: 'Later',
  next: 'Next',
  back: 'Back',
  start: 'Start',
  stop: 'Stop',
  approve: 'Approve',
  reject: 'Reject',
  confirm: 'Confirm',
  test: 'Test',
  showMore: 'Show more',
  showLess: 'Show less',

  // answers and states
  yes: 'Yes',
  no: 'No',
  ok: 'OK',
  active: 'Active',
  inactive: 'Inactive',
  required: 'Required',
  optional: 'optional',
  all: 'All',
  none: 'None',
  auto: 'Automatic',
  loading: 'Loading…',
  saving: 'Saving…',
  deleting: 'Deleting…',
  uploading: 'Uploading…',
  done: 'Done',
  failed: 'Failed',
  success: 'Success',
  error: 'Error',
  unknown: 'Unknown',

  // field names
  name: 'Name',
  type: 'Type',
  title: 'Title',
  description: 'Description',
  details: 'Details',
  status: 'Status',
  progress: 'Progress',
  duration: 'Duration',
  cost: 'Cost',
  file: 'File',
  folder: 'Folder',
  path: 'Path',
  version: 'Version',
  language: 'Language',

  // counts
  files: (n: number) => `${numEn(n)} ${plural(n, 'file')}`,
  characters: (n: number) => `${numEn(n)} ${plural(n, 'character')}`,

  languageName: {
    id: 'Indonesian',
    en: 'English',
  },
};
